import React, { useEffect, useState, useMemo } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { authSelector } from "../../apps/auth";
import Sidebar from "../../common/Sidebar";
import { HashLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { settingSelector, changeLimit, changePage, fetchSettings } from "../../apps/setting";
import { pageOptions } from "../../utils/constants";

const Creators = () => {
    const dispatch = useDispatch();
    const { user, token } = useSelector(authSelector);
    const { settings, total, limit, page } = useSelector(settingSelector);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [showTimeSpendModal, setShowTimeSpendModal] = useState(false);
    const navigate = useNavigate();
    const handleClose = () => setShowTimeSpendModal(false);

    const pageCount = useMemo(() => {
        const pageCounter = Math.ceil(total / limit);
        return pageCounter;
    }, [total, limit]);

    const [configObject] = useState({
        headers: {
            Authorization: "Bearer " + token,
        },
        params: {
            limit: limit,
            page: page,
            keyword: searchTerm
        },
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            await dispatch(fetchSettings({
                ...configObject, params: {
                    limit: limit,
                    page: page,
                    keyword: searchTerm
                },
            }));
        } catch (err) {
        } finally {
            setLoading(false);
        }
    };

    const limtHandler = async (e) => {
        await dispatch(changeLimit(e.target.value));
        await dispatch(fetchSettings({
            ...configObject, params: {
                limit: e.target.value,
                page: 1,
                keyword: searchTerm
            },
        }));
    }

    const handlePageClick = async (data) => {
        await dispatch(changePage(data.selected + 1));
        await dispatch(fetchSettings({
            ...configObject, params: {
                limit: limit,
                page: data.selected + 1,
                keyword: searchTerm
            },
        }));
    };

    const viewDetail = async (settingId) => {
        navigate(`/settings/${settingId}/edit`)
    }

    return (
        <>
            <Sidebar />
            {loading ? (
                <div className="spinner">
                    <HashLoader color="#757575" size={75} loading={true} />
                </div>
            ) : (
                <div className="card shadow-sm rounded">
                    {/* Header */}
                    <div className="card-header bg-white d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Settings</h3>

                        <div className="d-flex align-items-center gap-3">
                            <input
                                className="form-control form-control-sm"
                                style={{ minWidth: "200px" }}
                                placeholder="Search"
                                onChange={(e) => setSearchTerm(e.target.value)}
                                value={searchTerm}
                                type="search"
                            />
                            <Button className="btn search_btn" onClick={fetchData}>Search</Button>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                        <Table
                            striped
                            bordered
                            hover
                            size="sm"
                            className="align-middle mb-0"
                        >
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Meta Key</th>
                                    <th>Meta Slug</th>
                                    <th>Meta Value</th>
                                    <th>Meta Title</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {total > 0 ? (
                                    settings.map((item) => (
                                        <tr key={item?._id}>
                                            <td>{item?._id}</td>
                                            <td>{item?.meta_key}</td>
                                            <td>{item?.meta_slug}</td>
                                            <td>{item?.meta_value}</td>
                                            <td>{item?.meta_title}</td>
                                            <td>
                                                <button className="btn action_btn" onClick={() => viewDetail(item?._id)}>
                                                    <i className="fa fa-pencil"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted py-4">
                                            No record found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>

                    {/* Pagination & Limit Dropdown */}
                    {total > 0 && (
                        <div className="d-flex flex-wrap justify-content-between align-items-center px-3 py-3 border-top">
                            {/* Limit Selector */}
                            <div className="d-flex align-items-center gap-2">
                                <label className="mb-0 small">Show:</label>
                                <select className="form-select form-select-sm" onChange={limtHandler} value={limit}>
                                    {pageOptions.map((page) => (
                                        <option value={page.value} key={page.label}>
                                            {page.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Pagination */}
                            <ReactPaginate
                                previousLabel={"‹"}
                                nextLabel={"›"}
                                breakLabel={"..."}
                                pageCount={pageCount === 1 ? 1 : pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={3}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination mb-0"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                previousClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextClassName={"page-item"}
                                nextLinkClassName={"page-link"}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                activeClassName={"active"}
                            />
                        </div>
                    )}
                </div>
            )}
        </>
    );
};
export default Creators;
